exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".gift-list {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-justify-content: space-around;\n      -ms-flex-pack: distribute;\n          justify-content: space-around;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n      -ms-flex-align: center;\n          align-items: center;\n  margin-top: 0.5rem;\n  -webkit-flex-wrap: wrap;\n      -ms-flex-wrap: wrap;\n          flex-wrap: wrap;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader??ref--2-1!../node_modules/postcss-loader!../node_modules/less-loader/dist/cjs.js!./pages/activity/nationalTemplate/Gift/index.less
// module id = ../node_modules/css-loader/index.js??ref--2-1!../node_modules/postcss-loader/index.js!../node_modules/less-loader/dist/cjs.js!./pages/activity/nationalTemplate/Gift/index.less
// module chunks = 0